import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import Header from "./partials/1-header";
import Section1 from "./partials/2-section";
import Section2 from "./partials/3-section";
import Testemunhos from "./partials/4-testemunhos";
import Contato from "./partials/5-contato";
import Footer from "./partials/6-footer";
import { fetchAssinatura } from "services/assinatura";

class LandingPage extends Component {
  componentDidMount() {
    // Checa se a requisição retorna 401 (token inválido)
    // então mostra o botão de Login ou Dashboard.
    fetchAssinatura();
  }

  render() {
    const { history, user } = this.props;

    return (
      <div>
        <Header history={history} user={user} />
        <Section1 />
        <Section2 />
        <Testemunhos />
        <Contato />
        <Footer history={history} user={user} />
      </div>
    );
  }
};

LandingPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/views/LandingPage/LandingPage.jsx